import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import AsesmenGeriatriStore from "@/store/modules/AsesmenGeriatriStore";
import AsesmenAwalGadar from "@/store/modules/AsesmenAwalGadar";
import AsuhanKebidananGadarStore from "@/store/modules/AsuhanKebidananGadarStore";
import AsuhanKeperawatanGadarStore from "@/store/modules/AsuhanKeperawatanGadarStore";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import AsesmenPopulasiKhususStore from "@/store/modules/AsesmenPopulasiKhususStore";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import EncounterIndexStore from "@/store/modules/EncounterIndex";
import LaporanOperasiStore from "@/store/modules/LaporanOperasi";
import PasienSkdp from "@/store/modules/new/PasienSkdp";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import SuketDirawat from "@/store/modules/SuketDirawat";
import SuketGawatDarurat from "@/store/modules/SuketGawatDarurat";
import SuketKematian from "@/store/modules/SuketKematian";
import SuketPulang from "@/store/modules/SuketPulang";
import SuketPengawetanJenazah from "@/store/modules/SuketPengawetanJenazah";
import StorePersetujuanPlebotomi from "@/store/modules/PersetujuanPlebotomi";
import StorePersetujuanTransfusiDarah from "@/store/modules/PersetujuanTransfusiDarah";
import StorePersetujuanTransfusiInkompatibel from "@/store/modules/PersetujuanTransfusiInkompatibel";
import SuratKonsulRujukInternalStore from "@/store/modules/SuratKonsulRujukInternalStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import { resepStore } from "@/store/modules/resep";
import { storeAsesmenGigi } from "@/store/modules/asesmengigi";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import storeAsesmenKemoterapi from "@/store/modules/AsesmenKemoterapi";
import storeBilling from "@/store/modules/Billing";
import storeProtokolKemoterapi from "@/store/modules/ProtokolKemoterapi";
import { storeCatatanEdukasi } from "@/store/modules/catatanedukasi";
import { storeCatatanPraSedasi } from "@/store/modules/CatatanPraSedasiStore";
import { storeCeklistAlteplase } from "@/store/modules/CeklistAlteplaseStore";
import { storeCodeBlueActivation } from "@/store/modules/CodeBlueActivationStore";
import { storeCopy } from "@/store/modules/copy";
import { storeDischargePlanning } from "@/store/modules/DischargePlanningStore";
import { storeDnrConsent } from "@/store/modules/DnrConsentStore";
import { storeGeneralConsent } from "@/store/modules/GeneralConsentStore";
import { storeHasilPemeriksaanDarah } from "@/store/modules/HasilPemeriksaanDarahStore";
import { storeHasilPenunjang } from "@/store/modules/HasilPenunjang";
import { storeHasilUsg } from "@/store/modules/HasilUsgStore";
import { storeKonsul } from "@/store/modules/konsul";
import { storeMonitoringGds } from "@/store/modules/MonitoringGdsStore";
import { storeMonitoringTransfusi } from "@/store/modules/MonitoringTransfusiStore";
import { storeMonitoringTrombolisis } from "@/store/modules/MonitoringTrombolisisStore";
import { storeMonitoringTransportEksternal } from "@/store/modules/MonitoringTransportEksternalStore";
import { storeNyeri } from "@/store/modules/nyeri";
import { storePasien } from "@/store/modules/pasien";
import { storePemantauanAnestesi } from "@/store/modules/PemantauanAnestesiStore";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import { storePengantarKulturAntibiotika } from "@/store/modules/PengantarKulturAntibiotikaStore";
import { storePengkajianAkhirHayat } from "@/store/modules/PengkajianAkhirHayatStore";
import { storePenunjang } from "@/store/modules/penunjang";
import { storeOrderDarah } from "@/store/modules/OrderDarahStore";
import { storeOrderEmergensi } from "@/store/modules/OrderEmergensiStore";
import { storePermintaanObatPaket } from "@/store/modules/PermintaanObatPaketStore";
import { storePernyataanPemilihanDokter } from "@/store/modules/PernyataanPemilihanDokterStore";
import { storePersetujuanIntensif } from "@/store/modules/PersetujuanIntensifStore";
import { storePersetujuanObat } from "@/store/modules/PersetujuanObatStore";
import { storePersetujuanRanap } from "@/store/modules/PersetujuanRanapStore";
import { storeResepFarmasi } from "@/store/modules/resepfarmasi";
import { storeResume } from "@/store/modules/resume";
import { storeRiwayat } from "@/store/modules/riwayat";
import { storeRmk } from "@/store/modules/RmkStore";
import { storeRujukan } from "@/store/modules/rujukan";
import { storeRujukanDotsHiv } from "@/store/modules/RujukanDotsHivStore";
import { storeScreeningTrombolisis } from "@/store/modules/ScreeningTrombolisisStore";
import { storeSerahTerimaOperasi } from "@/store/modules/SerahTerimaOperasiStore";
import { storeSkriningRisikoJatuh } from "@/store/modules/skriningrisikojatuh";
import { storeSoap } from "@/store/modules/soap";
import { storeSuket } from "@/store/modules/suket";
import { storeSuratKeteranganKelahiran } from "@/store/modules/SuratKeteranganKelahiranStore";
import { storeSuratRujukanEdukasi } from "@/store/modules/SuratRujukanEdukasiStore";
import { storeSuratRujukanRanap } from "@/store/modules/SuratRujukanRanap";
import { storeVisumEtRepertum } from "@/store/modules/VisumEtRepertumStore";

export function resetStorePasienRanap(): void {
  storeRiwayat.resetForPasien();

  storePasien.CLEAR_PASIEN();
  RegisterKunjungan.reset();
  storeOrderDarah.reset();
  storeHasilPemeriksaanDarah.reset();
  StorePersetujuanTransfusiInkompatibel.reset();
  StorePersetujuanTransfusiDarah.reset();
  StorePersetujuanPlebotomi.reset();

  SoapRanapStore.reset();
  AsesmenAwalRanapMedisStore.reset();
  ResumeRanapStore.reset();
  TandaVitalStore.reset();
  resepStore.reset();
  storeHasilPenunjang.reset();
  SuketKematian.reset();
  storeSuratRujukanRanap.reset();
  storeRujukan.reset();
  storeBilling.reset();
  storeKonsul.clear();
  EncounterIndexStore.reset();
  LaporanOperasiStore.reset();
  CpptRanapStore.reset();
  CatatanPemberianObatStore.reset();
  storeSuratRujukanEdukasi.reset();
  storePengantarKulturAntibiotika.reset();
  storeGeneralConsent.reset();
  storePersetujuanRanap.reset();
  storePersetujuanIntensif.reset();
  storeDnrConsent.reset();
  storePernyataanPemilihanDokter.reset();
  storeVisumEtRepertum.reset();
  storeSerahTerimaOperasi.reset();
  storePermintaanObatPaket.reset();
  storeOrderEmergensi.reset();
  AsesmenPopulasiKhususStore.reset();
  storePengkajianAkhirHayat.reset();
  storeCodeBlueActivation.reset();
  storePersetujuanObat.reset();
  storeMonitoringTransportEksternal.reset();
  storePemantauanAnestesi.reset();
  storeMonitoringTransfusi.reset();
  storeMonitoringGds.reset();
  storeMonitoringTrombolisis.reset();
  storeSuratKeteranganKelahiran.reset();
  storeRmk.reset();
  storeHasilUsg.reset();
  storeCatatanPraSedasi.reset();
  storeDischargePlanning.reset();
  AsesmenGeriatriStore.reset();
  storeNyeri.reset();
}

export function resetStorePasienRalan(): void {
  AsesmenGadarMedisStore.clear();
  AsesmenGadarKeperawatanStore.clear();
  AsesmenSurveyPrimerGadarStore.clear();
  storeAsesmenGigi.clear();
  storeOrderDarah.reset();
  storeHasilPemeriksaanDarah.reset();
  StorePersetujuanTransfusiInkompatibel.reset();
  StorePersetujuanTransfusiDarah.reset();
  StorePersetujuanPlebotomi.reset();

  storeRiwayat.resetForPasien();

  storePasien.clear();

  storeKonsul.clearRecords();

  SoapRanapStore.reset();

  PasienSkdp.reset();

  CpptRanapStore.reset();

  CatatanPemberianObatStore.reset();

  storeOrderEmergensi.reset();

  SuratKonsulRujukInternalStore.reset();

  storeCopy.clear_copy_all();

  storeCatatanEdukasi.clear();
  storeResume.clearResume();
  storeBilling.reset();
  storeAssesmenRalan.reset();
  storePemeriksaanFisikRalan.clear();
  storePenunjang.reset();
  TandaVitalStore.reset();
  AsesmenMedisIgdStore.reset();
  SurveyPrimerIgdStore.reset();
  AsesmenKeperawatanGadarStore.reset();

  storeScreeningTrombolisis.reset();
  storeCeklistAlteplase.reset();
  storeMonitoringTrombolisis.reset();
  storeRujukanDotsHiv.reset();
  AsesmenGeriatriStore.reset();
  SuketPengawetanJenazah.reset();
  storeSkriningRisikoJatuh.reset();
  storeNyeri.reset();

  RegisterKunjungan.reset();
}

export function resetStoreDetailPasien(): void {
  storeRiwayat.resetForPasien();
  storePasien.clear();

  storeSoap.clear_soap_all();
  SoapRanapStore.reset();
  CpptRanapStore.reset();
  resepStore.setResep([]);
  storePenunjang.clear_list_ro();
  storePenunjang.clear_list_lab();
  storePenunjang.clear_hasil_ro();
  storePenunjang.clear_penunjang_lain();
  storeResepFarmasi.clear_list_resepfarmasi();
  storeResepFarmasi.clear_detail_resepfarmasi();
  storeSuket.clear_riwayatSK();
  SuketPulang.reset();
  SuketGawatDarurat.reset();
  SuketKematian.reset();
  SuketDirawat.reset();
  AsuhanKebidananGadarStore.clearListAskeb();
  AsuhanKeperawatanGadarStore.clearListAskep();
  AsesmenAwalGadar.clearData();
  storeResume.clearResume();
  storeBilling.clearBilling();
  AsesmenAwalRanapMedisStore.reset();
  ResumeRanapStore.reset();
  storeAsesmenKemoterapi.reset();
  storeProtokolKemoterapi.reset();
  storeAssesmenRalan.reset();
  TandaVitalStore.reset();
  LaporanOperasiStore.reset();
  CatatanPemberianObatStore.reset();
  RegisterKunjungan.reset();
}
